import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import md5 from "blueimp-md5";
import { useVuelidate } from "@vuelidate/core";
import { email, required, helpers, requiredIf } from "@vuelidate/validators";
import { mapActions, mapState } from "pinia";
//@ts-ignore
import BaseInput from "./UIKitComponents/BaseInput";
//@ts-ignore
import BaseTextarea from "./UIKitComponents/BaseTextarea";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
//@ts-ignore
import StaticSpinner from "@vueEntry/StaticSpinner.vue";
//@ts-ignore
import { sendGAEvent } from "@utils/GaEvents";
import { MACROTYPOLOGY } from "@customTypes/MacrotypologyEnum";
//@ts-ignore
import BaseAlert from "@vueEntry/UIKitComponents/BaseAlert.vue";
import { replaceAllTokens } from "@utils/StringUtils";
import { defineAsyncComponent, defineComponent } from "vue";
import { useModalStore } from "@store/ModalStore";
import { usePublicUserMenuStore } from "@store/PublicUserMenuStore";
//@ts-ignore
import { Modals } from "@customTypes/Modals";
//@ts-ignore
import { PHONE_REGEX } from "@utils/RegexUtils";
import { useValidator } from "@wkComposables/useValidator";
import { useMetadataStore } from "@wkWebSrc/js/store";
import { getOrNull } from "@utils/ObjectUtils";
var isChecked = value => value;
var phoneValidator = helpers.regex(PHONE_REGEX);
var requiredIfNotLogged = {
  required: requiredIf(function () {
    //@ts-ignore
    return !this.isUserLogged;
  })
};
export default defineComponent({
  name: "ContactAgencyBanner",
  components: {
    BaseInput,
    BaseTextarea,
    BaseButton,
    StaticSpinner,
    BaseAlert,
    "contact-agency-success": defineAsyncComponent(() => import("./Modals/ContactAgencySuccess.vue")),
    "limit-modal": defineAsyncComponent(() => import("./Modals/Status/LimitModal.vue")),
    "limit-saved-modal": defineAsyncComponent(() => import("./Modals/Status/LimitSavedModal.vue")),
    "unauthorized-modal": defineAsyncComponent(() => import("./Modals/Status/UnauthorizedModal.vue"))
  },
  props: {
    title: {
      type: String
    },
    icons: {
      type: Object,
      required: true
    },
    isUserLogged: {
      type: Boolean,
      default: false
    },
    labels: {
      type: Object,
      required: true
    },
    labelTextarea: {
      type: String
    },
    valueTextarea: {
      type: String
    },
    agencyData: {
      type: Object,
      required: true
    },
    endedAuction: {
      type: Boolean,
      required: false,
      default: false
    },
    // TODO: non è bello avere una proprietà publicUser in un componente per l'agency
    advertisingPublicUserID: {
      type: Number
    }
  },
  emits: ["open-login-modal"],
  setup() {
    var {
      isValid
    } = useValidator();
    return {
      isValid,
      v$: useVuelidate()
    };
  },
  data() {
    return {
      userInteraction: false,
      textareaMessage: "",
      name: "",
      email: "",
      phone: "",
      privacy: false,
      marketing: false,
      isTextAreaClicked: false,
      isSubmitting: false,
      isValidForm: false,
      responseContact: false,
      listingType: undefined,
      errorCode: -1,
      successModalData: null,
      successModalConfig: null,
      success: null,
      loginSuccess: false,
      show: false,
      errorMessage: ""
    };
  },
  validations() {
    return {
      name: Object.assign({}, requiredIfNotLogged),
      email: Object.assign(Object.assign({}, requiredIfNotLogged), {
        email
      }),
      phone: {
        phoneValidator
      },
      textareaMessage: {
        required
      },
      privacy: {
        required,
        isChecked
      }
    };
  },
  computed: Object.assign(Object.assign(Object.assign({
    readAndAcceptedByClicking() {
      var placeholder = "{0}";
      var tokens = this.labels.read_and_accepted_by_clicking.split(placeholder);
      return "".concat(tokens[0], " <span class=\"tw-font-semibold\">").concat(replaceAllTokens(placeholder, {
        "{0}": this.endedAuction ? this.labels.send : this.labels.requestInfos
      }), "</span>").concat(tokens[1]);
    },
    privacy_C_section() {
      return "".concat(this.labels.purpose, " C");
    },
    wikicasaUrl() {
      return window["wikicasaNewsURL"];
    },
    areInputsValid() {
      return !this.v$.name.$invalid && !this.v$.email.$invalid && !this.v$.phone.$invalid;
    },
    eventLocation() {
      return "".concat(this.pageName, " - ").concat(this.location);
    }
  }, mapState(usePublicUserMenuStore, ["publicUserId"])), mapState(usePublicUserMenuStore, {
    loggedUserEmail: "email"
  })), mapState(useMetadataStore, ["pageName", "location"])),
  watch: {
    userInteraction(cur) {
      var _a, _b, _c, _d, _e;
      if (!cur) return;
      sendGAEvent("specific_request_interaction", {
        event_location: this.eventLocation,
        agency_id: this.agencyData.agencyId,
        agency_name: getOrNull((_a = this.agencyData) === null || _a === void 0 ? void 0 : _a.agencyName),
        agency_place_id: null,
        agency_subscription_type: this.agencyData.premium ? "premium" : this.agencyData.lite ? "lite" : "free",
        agent_email: this.agencyData.agentEmail ? md5(this.agencyData.agentEmail) : null,
        agent_id: getOrNull(this.agencyData.agentId),
        agency_franchise_id: getOrNull(this.agencyData.franchiseId),
        agency_franchise_name: getOrNull(this.agencyData.franchiseName),
        product_price: this.agencyData.id ? parseFloat("".concat(this.agencyData.price).replace(".", "")) : null,
        real_estate_contract_type: ((_b = this.agencyData) === null || _b === void 0 ? void 0 : _b.rent) ? "rent" : "sale",
        real_estate_id: getOrNull((_c = this.agencyData) === null || _c === void 0 ? void 0 : _c.id),
        real_estate_place_id: getOrNull((_d = this.agencyData) === null || _d === void 0 ? void 0 : _d.placeID),
        real_estate_typology_name: getOrNull((_e = this.agencyData) === null || _e === void 0 ? void 0 : _e.typologyName),
        user_id: this.publicUserId == -1 ? null : this.publicUserId,
        user_email_hashed: md5(this.email || this.loggedUserEmail),
        user_email: this.email || this.loggedUserEmail,
        user_name: this.name,
        user_phone: getOrNull(this.phone)
      });
    }
  },
  created() {
    var _a;
    this.setLocation("Banner contatta agenzia (step 1)");
    this.textareaMessage = (_a = this.valueTextarea) !== null && _a !== void 0 ? _a : "";
  },
  methods: Object.assign(Object.assign(Object.assign({
    submitForm() {
      return __awaiter(this, void 0, void 0, function* () {
        this.isSubmitting = true;
        this.privacy = true;
        try {
          var isValid = yield this.v$.$validate();
          if (!isValid) return false;
          yield this.handleSendAgencyContact();
        } catch (err) {
          console.error(err);
          var {
            response
          } = err;
          if (response.status === 409) {
            sendGAEvent("specific_request_error_409", {
              event_location: this.eventLocation
            });
            this.errorMessage = this.labels.requestErrorDuplicatedLabel;
          } else if (response.status != 409) {
            this.errorMessage = this.labels.requestErrorLabel;
          }
          this.responseContact = false;
        } finally {
          this.isSubmitting = false;
        }
        return this.responseContact;
      });
    },
    handleSendAgencyContact() {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
      return __awaiter(this, void 0, void 0, function* () {
        var contactsData = {
          agentId: this.agencyData.agentId,
          referenceId: this.agencyData.id || -1,
          canonicalURL: this.agencyData.canonicalURL,
          notes: this.textareaMessage
        };
        if (this.agencyData.agencyId == this.advertisingPublicUserID) contactsData["advertisingPublicUserId"] = this.advertisingPublicUserID;else contactsData["agencyId"] = this.agencyData.agencyId;
        if (!this.isUserLogged) {
          contactsData.name = this.name;
          contactsData.email = this.email;
          contactsData.phone = this.phone;
        }
        var res = yield this.sendAgencyContact(contactsData);
        if (!res) return;
        var price = null;
        var agencyWithId = !!this.agencyData.id;
        if (agencyWithId) price = parseFloat("".concat(this.agencyData.price).replace(".", ""));
        var {
          agencyData: data
        } = this;
        if (this.endedAuction) {
          sendGAEvent("auction_consultant_lead", {
            event_location: "".concat(this.pageName, " - Banner asta scaduta"),
            auction_consultant_id: (_a = this.agencyData) === null || _a === void 0 ? void 0 : _a.agencyId,
            auction_consultant_name: getOrNull((_b = this.agencyData) === null || _b === void 0 ? void 0 : _b.agencyName),
            real_estate_id: getOrNull((_c = this.agencyData) === null || _c === void 0 ? void 0 : _c.id),
            real_estate_contract_type: "auction",
            real_estate_place_id: getOrNull((_d = this.agencyData) === null || _d === void 0 ? void 0 : _d.placeID),
            user_id: this.publicUserId == -1 ? null : this.publicUserId,
            contract_type: "auction",
            user_email_hashed: md5(this.email || this.loggedUserEmail),
            user_email: this.email || this.loggedUserEmail
          });
        } else {
          if (!this.advertisingPublicUserID) sendGAEvent("specific_request_lead", {
            event_location: this.eventLocation,
            agency_id: this.agencyData.agencyId,
            agency_name: getOrNull((_e = this.agencyData) === null || _e === void 0 ? void 0 : _e.agencyName),
            agency_place_id: null,
            agency_subscription_type: this.agencyData.premium ? "premium" : this.agencyData.lite ? "lite" : "free",
            agent_email: data.agentEmail ? md5(data.agentEmail) : null,
            agent_id: getOrNull(this.agencyData.agentId),
            agency_franchise_id: getOrNull(this.agencyData.franchiseId),
            agency_franchise_name: getOrNull(this.agencyData.franchiseName),
            product_price: data.id ? price : null,
            real_estate_contract_type: ((_f = this.agencyData) === null || _f === void 0 ? void 0 : _f.rent) ? "rent" : "sale",
            real_estate_id: getOrNull((_g = this.agencyData) === null || _g === void 0 ? void 0 : _g.id),
            real_estate_place_id: getOrNull((_h = this.agencyData) === null || _h === void 0 ? void 0 : _h.placeID),
            real_estate_typology_name: getOrNull((_j = this.agencyData) === null || _j === void 0 ? void 0 : _j.typologyName),
            user_id: this.publicUserId == -1 ? null : this.publicUserId,
            user_email_hashed: md5(this.email || this.loggedUserEmail),
            user_email: this.email || this.loggedUserEmail,
            user_name: this.name,
            user_phone: this.phone
          });else sendGAEvent("specific_request_lead", {
            event_location: this.eventLocation,
            advertisingPublicUserID: this.advertisingPublicUserID,
            agency_name: null,
            agency_place_id: null,
            agency_subscription_type: "free",
            agent_email: null,
            agent_id: null,
            agency_franchise_id: null,
            agency_franchise_name: null,
            product_price: data.id ? price : null,
            real_estate_contract_type: ((_k = this.agencyData) === null || _k === void 0 ? void 0 : _k.rent) ? "rent" : "sale",
            real_estate_id: getOrNull((_l = this.agencyData) === null || _l === void 0 ? void 0 : _l.id),
            real_estate_place_id: getOrNull((_m = this.agencyData) === null || _m === void 0 ? void 0 : _m.placeID),
            real_estate_typology_name: getOrNull((_o = this.agencyData) === null || _o === void 0 ? void 0 : _o.typologyName),
            user_id: this.publicUserId == -1 ? null : this.publicUserId,
            user_email_hashed: md5(this.email || this.loggedUserEmail),
            user_email: this.email || this.loggedUserEmail,
            user_name: this.name,
            user_phone: this.phone
          });
        }
        var modalConfig = {
          showSaveSearch: true,
          showGenericRequest: false
        };
        if (agencyWithId && (data.macroTypology != MACROTYPOLOGY.BUSINESS || ((_p = this.listingType) === null || _p === void 0 ? void 0 : _p.includes(this.agencyData.typology))) && data.macroTypology != MACROTYPOLOGY.ACTIVITY) modalConfig.showGenericRequest = true;else modalConfig.showSaveSearch = false;
        this.successModalData = Object.assign(Object.assign({}, data), contactsData);
        this.successModalConfig = modalConfig;
        this.show = true;
        //Opening the success modal! // TODO: deprecate?
        this.success = true;
      });
    },
    openPrivacyDisclaimer() {
      window.open("/privacy", "_blank", "scrollbars=yes, width=550, height=600");
    },
    handleShowErrorModal(errorCode) {
      this.errorCode = errorCode;
    },
    openSigninModal() {
      this.show = false;
      this.setShowModal(Modals.signInModal);
    },
    openLoginModal() {
      this.show = false;
      this.$emit("open-login-modal");
    }
  }, mapActions(useModalStore, ["setShowModal"])), mapActions(usePublicUserMenuStore, ["sendAgencyContact"])), mapActions(useMetadataStore, ["setLocation"]))
});